export function AWBNumberNormslization(data){
    return String(data || '')
      .split(/[\s,]+/)
      .filter(Boolean);
}

export function custom_sort(a, b) {
  return new Date(b.LastModified).getTime() - new Date(a.LastModified).getTime();
}
export function  isValidUrl (urlString){
  var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
  '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
return !!urlPattern.test(urlString);
}

export async function checkFileType(extension){
  try{
      let imageExtensions = ['jpeg', 'jpg', 'png', 'gif', 'tiff', 'tif', 'bmp', 'svg', 'raw', 'psd', 'ai', 'eps', 'pdf', 'webp', 'heic', 'heif', 'ico', 'tga', 'pcx', 'wmf', 'emf', 'exr', 'pnm'];
      let videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'm4v', 'mpeg', '3gp', 'webm', 'asf', 'vob', 'ts', 'swf', 'rm', 'mpg', 'mts', 'ogv', 'm2ts', 'flv'];
      if(imageExtensions.includes(extension)){
          return 'Image';
      }
      if(videoExtensions.includes(extension)){
          return 'Video';
      }
      return 'Unknown';
  }catch(e){
      console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/services/utility.js